/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export function percentage(partialValue: number, totalValue: number) {
  return totalValue === 0 ? 0 : (100 * partialValue) / totalValue;
}

export function convertToPercent(value: number | string, fixed = 2): number {
  return parseFloat((Number(value) * 100).toFixed(fixed));
}

export function sum(list: number[]): number {
  return list.reduce((prev, curr) => prev + curr, 0);
}
